import {NgModule} from '@angular/core';
import {NcSubmitButtonComponent} from './nc-submit-button/nc-submit-button.component';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import {NcProcessingDialogComponent, NcProcessingDialogModule} from 'nc-processing-dialog';
import {NcInformationDialogComponent, NcInformationDialogModule} from 'nc-information-dialog';


@NgModule({
  declarations: [NcSubmitButtonComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    NcProcessingDialogModule,
    NcInformationDialogModule
  ],
  exports: [NcSubmitButtonComponent],
  entryComponents: [NcProcessingDialogComponent, NcInformationDialogComponent]
})
export class NcSubmitButtonModule {
}
